import { format, parseISO, isToday, isTomorrow, isPast, startOfDay } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const formatDate = (date, formatStr = 'dd/MM/yyyy') => {
  if (!date) return '';
  try {
    // Se for objeto Date, converte para ISO string
    const dateStr = date instanceof Date ? date.toISOString() : date;
    return format(parseISO(dateStr), formatStr, { locale: ptBR });
  } catch {
    return date;
  }
};

export const formatDateDisplay = (date) => {
  if (!date) return '';
  
  // Criar data local a partir da string ISO para evitar problemas de timezone
  const [year, month, day] = date.split('-');
  const localDate = new Date(year, month - 1, day);
  
  // Criar data atual sem hora para comparação correta
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  
  // Comparar apenas ano, mês e dia
  const isToday = localDate.getDate() === today.getDate() && 
                  localDate.getMonth() === today.getMonth() && 
                  localDate.getFullYear() === today.getFullYear();
  
  const isTomorrow = localDate.getDate() === tomorrow.getDate() && 
                     localDate.getMonth() === tomorrow.getMonth() && 
                     localDate.getFullYear() === tomorrow.getFullYear();
  
  if (isToday) return 'Hoje';
  if (isTomorrow) return 'Amanhã';
  
  return format(localDate, "EEEE, d 'de' MMMM", { locale: ptBR });
};

export const formatTime = (time) => {
  if (!time) return '';
  return time;
};

export const isDatePast = (date) => {
  if (!date) return false;
  
  // Criar data local a partir da string ISO para evitar problemas de timezone
  const [year, month, day] = date.split('-');
  const localDate = new Date(year, month - 1, day);
  
  return isPast(startOfDay(localDate));
};

export const formatPhone = (phone) => {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  
  if (cleaned.length === 11) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`;
  }
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
  }
  
  return phone;
};

export const getInitials = (name) => {
  if (!name) return '';
  return name
    .split(' ')
    .slice(0, 2)
    .map(n => n[0])
    .join('')
    .toUpperCase();
};

export const statusColors = {
  agendado: 'bg-gray-500/20 text-gray-400 border-gray-500/30',
  pending_payment: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
  confirmed: 'bg-green-500/20 text-green-400 border-green-500/30',
  cliente_chegou: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  em_atendimento: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
  confirmado: 'bg-green-500/20 text-green-400 border-green-500/30',
  cancelado: 'bg-red-500/20 text-red-400 border-red-500/30',
  expired: 'bg-red-500/20 text-red-300 border-red-500/30',
  concluido: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  nao_compareceu: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  encaixe: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
};

export const statusLabels = {
  agendado: 'Agendado',
  pending_payment: 'Aguardando sinal',
  confirmed: 'Confirmado',
  cliente_chegou: 'Cliente Chegou',
  em_atendimento: 'Em Atendimento',
  confirmado: 'Confirmado',
  cancelado: 'Cancelado',
  expired: 'Sinal expirado',
  concluido: 'Concluído',
  nao_compareceu: 'Não Compareceu',
  encaixe: 'Encaixe',
};

export const isNonTerminalStatus = (status) => {
  const terminalStatuses = ['cancelado', 'expired', 'concluido', 'nao_compareceu'];
  return !terminalStatuses.includes(status);
};

export const paymentStatusColors = {
  ativo: 'bg-green-500/20 text-green-400',
  trial: 'bg-blue-500/20 text-blue-400',
  atrasado: 'bg-yellow-500/20 text-yellow-400',
  cancelado: 'bg-red-500/20 text-red-400',
};

export const paymentStatusLabels = {
  ativo: 'Ativo',
  trial: 'Trial',
  atrasado: 'Atrasado',
  cancelado: 'Cancelado',
};

export const formatMonthDisplay = (monthStr) => {
  if (!monthStr) return '';
  try {
    // monthStr está no formato YYYY-MM
    const [year, month] = monthStr.split('-');
    const date = new Date(year, month - 1, 1);
    return format(date, "MMMM 'de' yyyy", { locale: ptBR });
  } catch {
    return monthStr;
  }
};

export const cn = (...classes) => classes.filter(Boolean).join(' ');
